import { createEditButton } from '../../../../components'
import { UpsertEventTypeModal } from '../UpsertEventType/UpsertEventTypeModal'

// TODO Add subject / remove for good
export const EventTypeEditButton = createEditButton(UpsertEventTypeModal, 'event_types' as never)
